import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const TasksPlaceholderIcon = (props: IconProps) => (
  <Icon width="361px" height="374px" viewBox="0 0 361 374" {...props}>
    <ellipse
      opacity="0.4"
      cx="179.859"
      cy="187.556"
      rx="179.859"
      ry="179.765"
      fill="#D9F2E0"
    />
    <mask
      id="mask0_4471_1242333"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="73"
      y="63"
      width="21"
      height="20"
    >
      <rect
        x="73.5029"
        y="63.4473"
        width="20.0463"
        height="18.9226"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_4471_1242333)">
      <path
        d="M123.619 115.763H77.5496C86.3859 115.762 93.5496 108.599 93.5496 99.7627V79.4473C93.5496 70.6109 86.3859 63.4475 77.5496 63.4473H123.619V115.763Z"
        fill="white"
      />
    </g>
    <path
      d="M93.5491 63.4473H352.832C357.251 63.4473 360.832 67.029 360.832 71.4473V113.328C360.832 117.746 357.251 121.328 352.832 121.328H101.549C97.1308 121.328 93.5491 117.746 93.5491 113.328V63.4473Z"
      fill="white"
    />
    <line
      x1="185.757"
      y1="80.3691"
      x2="341.014"
      y2="80.3692"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="113.368"
      y1="80.3691"
      x2="176.189"
      y2="80.3691"
      stroke="#D9F2E0"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="113.368"
      y1="91.5"
      x2="341.014"
      y2="91.5"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="113.368"
      y1="103.744"
      x2="169.507"
      y2="103.744"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <mask
      id="mask1_4471_1242333"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="73"
      y="253"
      width="21"
      height="20"
    >
      <rect
        x="73.5029"
        y="253.787"
        width="20.0463"
        height="18.9226"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_4471_1242333)">
      <path
        d="M123.619 306.103H77.5496C86.3859 306.102 93.5496 298.939 93.5496 290.103V269.787C93.5496 260.951 86.3859 253.787 77.5496 253.787H123.619V306.103Z"
        fill="white"
      />
    </g>
    <path
      d="M93.5491 253.787H352.832C357.251 253.787 360.832 257.369 360.832 261.787V303.668C360.832 308.086 357.251 311.668 352.832 311.668H101.549C97.1308 311.668 93.5491 308.086 93.5491 303.668V253.787Z"
      fill="white"
    />
    <line
      x1="113.368"
      y1="270.709"
      x2="207.372"
      y2="270.709"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="218.054"
      y1="270.709"
      x2="312.058"
      y2="270.709"
      stroke="#D9F2E0"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="113.368"
      y1="281.84"
      x2="341.014"
      y2="281.84"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="113.368"
      y1="294.084"
      x2="180.643"
      y2="294.084"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <ellipse
      cx="98.0038"
      cy="309.441"
      rx="13.3642"
      ry="13.3571"
      fill="#B3E5C0"
    />
    <path
      d="M90.8577 315.285H93.4563V307.493H90.8577V315.285ZM105.15 308.143C105.15 307.428 104.565 306.844 103.851 306.844H99.7513L100.369 303.877L100.388 303.669C100.388 303.403 100.278 303.156 100.102 302.981L99.4135 302.299L95.1388 306.578C94.8985 306.812 94.7555 307.136 94.7555 307.493V313.986C94.7555 314.701 95.3402 315.285 96.0548 315.285H101.902C102.441 315.285 102.902 314.96 103.097 314.493L105.059 309.915C105.117 309.766 105.15 309.61 105.15 309.441V308.143Z"
      fill="white"
    />
    <mask
      id="mask2_4471_1242333"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="-4"
      y="159"
      width="21"
      height="20"
    >
      <rect
        x="-3.34106"
        y="159.174"
        width="20.0463"
        height="18.9226"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask2_4471_1242333)">
      <path
        d="M46.7749 211.489H0.705566C9.54192 211.489 16.7056 204.326 16.7056 195.489V175.174C16.7056 166.337 9.54191 159.174 0.705566 159.174H46.7749V211.489Z"
        fill="white"
      />
    </g>
    <path
      d="M16.7051 159.174H275.988C280.407 159.174 283.988 162.756 283.988 167.174V209.055C283.988 213.473 280.407 217.055 275.988 217.055H24.7051C20.2868 217.055 16.7051 213.473 16.7051 209.055V159.174Z"
      fill="white"
    />
    <line
      x1="36.5239"
      y1="176.096"
      x2="230.759"
      y2="176.096"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="152.347"
      y1="187.227"
      x2="264.169"
      y2="187.227"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="36.5239"
      y1="187.227"
      x2="140.551"
      y2="187.227"
      stroke="#D9F2E0"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="36.5239"
      y1="199.471"
      x2="188.439"
      y2="199.471"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <ellipse
      cx="23.3874"
      cy="219.279"
      rx="13.3642"
      ry="13.3571"
      fill="#B3E5C0"
    />
    <g clipPath="url(#clip0_4471_1242333)">
      <path
        d="M16.2412 225.123H18.8398V217.331H16.2412V225.123ZM30.5334 217.98C30.5334 217.266 29.9488 216.682 29.2342 216.682H25.1349L25.752 213.715L25.7715 213.507C25.7715 213.241 25.6611 212.994 25.4857 212.818L24.7971 212.137L20.5224 216.416C20.282 216.649 20.1391 216.974 20.1391 217.331V223.824C20.1391 224.538 20.7238 225.123 21.4384 225.123H27.2852C27.8244 225.123 28.2857 224.798 28.4806 224.331L30.4425 219.753C30.501 219.604 30.5334 219.448 30.5334 219.279V217.98Z"
        fill="white"
      />
    </g>
    <rect
      x="252.805"
      y="32.2793"
      width="56.7977"
      height="20.0357"
      rx="10.0179"
      fill="#ECF9EF"
    />
    <ellipse
      cx="263.942"
      cy="42.2963"
      rx="3.34103"
      ry="3.33929"
      fill="#B3E5C0"
    />
    <ellipse
      cx="275.079"
      cy="42.2963"
      rx="3.34103"
      ry="3.33929"
      fill="#B3E5C0"
    />
    <ellipse
      cx="286.216"
      cy="42.2963"
      rx="3.34103"
      ry="3.33929"
      fill="#B3E5C0"
    />
    <ellipse
      cx="297.353"
      cy="42.2963"
      rx="3.34105"
      ry="3.33929"
      fill="#B3E5C0"
    />
    <defs>
      <clipPath id="clip0_4471_1242333">
        <rect
          width="15.5915"
          height="15.5833"
          fill="white"
          transform="translate(15.5916 211.488)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(TasksPlaceholderIcon);
